import { render } from "./polar-chart.vue?vue&type=template&id=10ed9975"
import script from "./polar-chart.vue?vue&type=script&lang=js"
export * from "./polar-chart.vue?vue&type=script&lang=js"

import exportComponent from "c:\\jenkins\\workspace\\Client_Windows_build\\node_modules\\vue-loader\\dist\\exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render]])

export default __exports__